






































import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {
    InsBanner: () => import('@/components/base/InsBanner.vue'),
    InsFun: () => import('@/components/business/home/InsFun.vue'),
    InsFeature: () => import('@/components/business/home/InsFeature.vue'),
    InsFacebook: () => import('@/components/business/home/InsFacebook.vue'),
    InsNews: () => import('@/components/business/home/InsNews.vue'),
    InsHomeRnp: () => import('@/components/business/home/InsHomeRNP.vue')

    // InsAboutUs: () => import('@/components/business/home/InsAboutUs.vue'),
    // CmxCmsList: () => import('@/components/business/home/InsCmsList.vue'),
    // InsCalendar: () => import('@/components/business/home/InsCalendar.vue'),
    // InsFullCalendar: () => import('@/components/business/home/InsFullCalendar.vue'),
    // InsBaiduMap: () => import('@/components/business/promotion/InsBaiduMap.vue')
  }
})
export default class InsHome extends Vue {
  swiperOption: object = {
    loop: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    autoHeight: true, // 高度随内容变化
    observer: true, // 修改swiper自己或子元素时，自动初始化swiper
    observeParents: true // 修改swiper的父元素时，自动初始化swiper
  };

  get AreaCode () {
    return localStorage.getItem('AreaCode') || '';
  }

  created () {
    let keywords = document.createElement('meta');
    keywords.setAttribute('name', 'keywords');
    // keywords.setAttribute('content', require('../sdk/common/SeoData').seoItem['home'].keyword);
    document.head.appendChild(keywords);
    let description = document.createElement('meta');
    description.setAttribute('name', 'description');
    // description.setAttribute('content', require('../sdk/common/SeoData').seoItem['home'].description);
    document.head.appendChild(description);
    document.dispatchEvent(new Event('render-event'));
  }

  mounted () {

  }
}
